(function () {
  var params = new URLSearchParams(window.location.search);
  var productHandle = (params.get('product') || '').trim();
  var variantId = (params.get('variant') || '').trim();
  var productTitle = (params.get('title') || '').trim();
  var isCartRequest = params.get('cart') === 'request-price';

  if (!productHandle && !isCartRequest) return;

  var productLabel = productTitle || productHandle;
  var inquiryHeading = productHandle ? 'Upit za proizvod' : 'Upit iz korpe';
  var inquiryCopy = productHandle
    ? 'Pošaljite nam poruku u vezi modela: '
    : 'Pošaljite nam upit za proizvod iz korpe koji je označen kao upit za cijenu.';
  var messageText = productHandle
    ? 'Poštovani, želim poslati upit za cijenu za ovaj model: ' + productLabel
    : 'Poštovani, želim poslati upit za proizvod iz korpe koji je označen kao upit za cijenu.';

  if (variantId) {
    messageText += ' (varijanta ID: ' + variantId + ')';
  }

  document.querySelectorAll('[data-oj-contact-inquiry]').forEach(function (notice) {
    notice.hidden = false;
  });

  document.querySelectorAll('[data-oj-contact-inquiry-heading]').forEach(function (heading) {
    heading.textContent = inquiryHeading;
  });

  document.querySelectorAll('[data-oj-contact-inquiry-copy]').forEach(function (copy) {
    copy.textContent = inquiryCopy;

    if (productHandle) {
      var label = document.createElement('strong');
      label.setAttribute('data-oj-contact-product-label', '');
      label.textContent = productLabel;
      copy.appendChild(label);
    }
  });

  document.querySelectorAll('[data-oj-contact-product-label]').forEach(function (label) {
    label.textContent = productLabel;
  });

  document.querySelectorAll('[data-oj-contact-product-field]').forEach(function (field) {
    field.value = productHandle;
  });

  document.querySelectorAll('[data-oj-contact-variant-field]').forEach(function (field) {
    field.value = variantId;
  });

  document.querySelectorAll('[data-oj-contact-product-title-field]').forEach(function (field) {
    field.value = productTitle;
  });

  document.querySelectorAll('[data-oj-contact-request-context-field]').forEach(function (field) {
    field.value = productHandle ? 'product-request-price' : 'cart-request-price';
  });

  document.querySelectorAll('[data-oj-contact-quote-type]').forEach(function (radio) {
    radio.checked = true;
  });

  document.querySelectorAll('[data-oj-contact-message]').forEach(function (messageField) {
    if (!messageField.value.trim()) {
      messageField.value = messageText;
    }
  });
})();
